// Libraries
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";

// Child Components
import Language from "../../common/misc/language";
import Header from "../../common/header";
import MapView from "../../common/map/mapView";
import Expire from "../../common/expire";
import Back from "../../common/form/back";

import { getEntities } from "../../../services/apiService";

// Constants
const baseUrl = process.env.REACT_APP_API_URL;

// Modal Component
var appElement = document.getElementById("root");
Modal.setAppElement(appElement);

class OverView extends Component {
  constructor(props) {
    super(props);
    this.state = { modalIsOpen: false };

    this.state = {
      pois: [],
      selectedPoi: null,
      language: "en",
    };
  }

  // Retrive data from the server
  async componentDidMount() {
    // Get Data
    const { data: pois } = await getEntities("v2/gallery");
    if (pois.length === 0) return;

    this.setState({ pois });

    // Tables Current Page History
    const searchParams = new URLSearchParams(window.location.search);
    const poiQuery = searchParams.get("id");

    if (poiQuery) {
      const selectedPoi = pois.find((p) => p._id === poiQuery);

      this.setState({
        selectedPoi: selectedPoi,
      });

      // Open Modal
      this.openModal();
    }
  }

  // Marker view classes event handler
  handleMarkerClass = (e) => {
    if (e.target.classList.value === "map-box active") {
      return;
    }

    e.target.classList.toggle("active");
    e.currentTarget.classList.toggle("active");

    document
      .querySelectorAll(".map-tick:not(.active)")
      .forEach((el) => (el.style.display = "none"));
  };

  // Filter Pois on Marker click event handler
  handleMarkerClick = (e) => {
    const selectedPoi = e.target.innerHTML;
    const poi = this.state.pois.find((p) => p.title_en === selectedPoi);

    // Open Modal
    this.openModal();

    this.setState({
      selectedPoi: poi,
    });
  };

  // Filter event handler
  handlePoiSelect = ({ currentTarget: input }) => {
    const poi = this.state.pois.find((p) => p._id === input.value);

    this.setState({
      selectedPoi: poi,
    });
  };

  handleLanguageSelect = ({ currentTarget: input }) => {
    const selectedLanguage = input.value;
    this.setState({ language: selectedLanguage });
  };

  // Reset Button Event Handler
  handleReset = () => {
    document
      .querySelectorAll(".active")
      .forEach((el) => el.classList.remove("active"));

    this.setState({
      selectedPoi: null,
    });

    document
      .querySelectorAll(".map-tick:not(.active)")
      .forEach((el) => (el.style.display = "initial"));
  };

  // Open Modal Function
  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  // Close Modal Function
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  // Modal Close Event Handler
  handleModalCloseRequest = () => {
    this.setState({ modalIsOpen: false });
  };

  // Modal Save Event Handler
  /*
  handleSaveClicked = (event) => {
    // event.preventDefault();
    this.setState({ modalIsOpen: false });
  };
  */

  render() {
    const { selectedPoi, language, pois } = this.state;

    return (
      <div className="col alt-table-responsive mt-1">
        <Header
          icon="bx bx-category-alt"
          title="Overview"
          hasButton={false}
          dependency={null}
          path="#"
          name="View all
              Histocaches"
          // onClick={this.handleReset}
        />

        {pois.length !== 0 ? (
          <Fragment>
            <div className="row py-3">
              <div className="col">
                <MapView
                  style={{ height: "65vh", width: "100%" }}
                  pois={this.state.pois}
                  lang={language}
                  // onClick={this.handleMarkerClick}
                  // onMouseDown={this.handleMarkerClass}
                  //onClick={this.openModal}
                />
              </div>
            </div>
            <Modal
              className="Modal__Bootstrap modal-dialog"
              closeTimeoutMS={150}
              isOpen={this.state.modalIsOpen}
              onRequestClose={this.handleModalCloseRequest}
            >
              <div className="modal-content vertical-content">
                <div className="modal-header">
                  {selectedPoi ? (
                    <h5 className="modal-title modal-title-text">
                      <strong>
                        {language === "en"
                          ? selectedPoi.title_en
                          : selectedPoi.title_de}
                      </strong>
                    </h5>
                  ) : null}

                  <button
                    type="button"
                    className="close"
                    onClick={this.handleModalCloseRequest}
                  >
                    <span aria-hidden="true">
                      <i className="bx bx-x bx-md"></i>
                    </span>
                    <span className="sr-only">Close</span>
                  </button>
                </div>
                <div className="modal-body">
                  {selectedPoi ? (
                    <div className="row justify-content-center">
                      <div className="col-md-10 col-sm-12">
                        <img
                          className="image-preview"
                          src={`${baseUrl}/pois/${selectedPoi._id}/${selectedPoi.filename}`}
                          alt={selectedPoi.title_en}
                        />

                        <p className="modal-caption mt-2">
                          <small>
                            {language === "en"
                              ? selectedPoi.caption_en
                              : selectedPoi.caption_de}
                          </small>
                        </p>

                        <p
                          className="text-justify mt-3"
                          style={{ color: "white" }}
                        >
                          {language === "en"
                            ? selectedPoi.description_en
                            : selectedPoi.description_de}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="modal-footer">
                  <Back onClick={this.handleModalCloseRequest} />
                  <Link
                    type="button"
                    className="btn btn-warning rounded"
                    to={selectedPoi ? `/dashboard/poi/${selectedPoi._id}` : "#"}
                  >
                    <i className="fa fa-pencil"></i> Edit Details
                  </Link>
                  <Language
                    onChange={this.handleLanguageSelect}
                    selectedLang={language}
                  />
                </div>
              </div>
            </Modal>
          </Fragment>
        ) : (
          <div className="row">
            <div className="col-sm-12 align-self-center">
              <Expire delay={5000}>
                <div className="loader">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </Expire>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default OverView;
